export default __webpack_public_path__ + "static/media/Major Rune Stone of the Furious Swipe.036ae75c.jpg";